import { BsPencilSquare } from "react-icons/bs";

import "./editButton.css";

type EditButtonProps = {
  onEditButtonClick: () => void;
  style?: React.CSSProperties;
};

export default function EditButton({
  onEditButtonClick,
  style
}: EditButtonProps) {

  return (
    <div className="editButton" style={style} onClick={onEditButtonClick}>
      <BsPencilSquare />
      Edit
    </div>
  );
}